import ReactGA from "react-ga4";
import { createRoot } from "react-dom/client";

import { StrictMode } from "react";

import App from "./App.jsx";

import "./css/index.css";

if (import.meta.env.VITE_ANALYTICS) {
	ReactGA.initialize(import.meta.env.VITE_ANALYTICS);
	ReactGA.send("pageview");
}

createRoot(document.getElementById("root")).render(
	<StrictMode>
		<App />
	</StrictMode>
);
